import styled from 'styled-components';

export const ErrorConteiner = styled.div`
  font-size: 1.4rem;
  color: var(--error-color);
  position: absolute;
`;
